import { render, staticRenderFns } from "./batchHintDialog.vue?vue&type=template&id=7071a79a&scoped=true"
import script from "./batchHintDialog.vue?vue&type=script&lang=js"
export * from "./batchHintDialog.vue?vue&type=script&lang=js"
import style0 from "./batchHintDialog.vue?vue&type=style&index=0&id=7071a79a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071a79a",
  null
  
)

export default component.exports